import { gql } from '@edreamsodigeo/frontend-api-client';

export const ADD_PRODUCT_TO_UNIVERSAL_SHOPPING_BASKET = gql`
  mutation SB_AddProductToUniversalShoppingBasket(
    $request: AddProductToUniversalShoppingBasketRequest!
  ) {
    addProductToUniversalShoppingBasket(request: $request) {
      success
    }
  }
`;

export const REMOVE_PRODUCT_FROM_UNIVERSAL_SHOPPING_BASKET = gql`
  mutation SB_RemoveProductFromUniversalShoppingBasket(
    $request: RemoveProductFromUniversalShoppingBasketRequest!
  ) {
    removeProductFromUniversalShoppingBasket(request: $request) {
      success
    }
  }
`;

export const ADD_CONTACT_DETAILS_TO_UNIVERSAL_SHOPPING_BASKET = gql`
  mutation SB_AddContactDetailsToUniversalShoppingBasket(
    $request: AddContactDetailsToUniversalShoppingBasketRequest!
  ) {
    addContactDetailsToUniversalShoppingBasket(request: $request) {
      success
    }
  }
`;

export const CREATE_UNIVERSAL_SHOPPING_BASKET = gql`
  mutation SB_CreateUniversalShoppingBasket {
    createUniversalShoppingBasket {
      shoppingBasketId
      shoppingBasketToken {
        token
      }
    }
  }
`;
